export class AnnouncementsFilterModel {
    pageSize: number;
    pageNumber: number;
    searchText: string;
    filter = {} as {
        text?: string;
        cabsIds: number[];
    };
}
